module.exports = __webpack_public_path__ + "media/images/one-are-we-footer-7535e2632b8fc0742802b2cb29e3e69e.svg";